import { DocumentationTabTypes } from '../components/documentation/tabs/types';
import { DocumentationPageType } from '../components/documentation/types';
import { telemetry } from '../telemetry';

const METADATA_TABS_STORAGE_KEY = 'documentation_metadata_tabs';

export interface StoredMetadataTabsPerOrg {
  [DocumentationPageType.metadataTypes]: DocumentationTabTypes[];
}

export interface StoredMetadataTabs {
  [crmOrgId: string]: StoredMetadataTabsPerOrg;
}

/**
 * Load user's selected metadata tabs from local storage for a specific CRM org
 */
export const loadMetadataTabs = (crmOrgId: string): StoredMetadataTabsPerOrg | null => {
  try {
    const stored = localStorage.getItem(METADATA_TABS_STORAGE_KEY);
    if (!stored) {
      return null;
    }
    const allOrgTabs: StoredMetadataTabs = JSON.parse(stored);
    return allOrgTabs[crmOrgId] || null;
  } catch (error) {
    telemetry.captureError(error);
    return null;
  }
};

/**
 * Save user's selected metadata tabs to local storage for a specific CRM org
 */
export const saveMetadataTabs = (crmOrgId: string, tabs: StoredMetadataTabsPerOrg): void => {
  try {
    const stored = localStorage.getItem(METADATA_TABS_STORAGE_KEY);
    let allOrgTabs: StoredMetadataTabs = {};

    if (stored) {
      allOrgTabs = JSON.parse(stored);
    }

    allOrgTabs[crmOrgId] = tabs;

    localStorage.setItem(METADATA_TABS_STORAGE_KEY, JSON.stringify(allOrgTabs));
  } catch (error) {
    telemetry.captureError(error);
  }
};

/**
 * Get only the user-selected tabs (excluding default tabs)
 */
export const getUserSelectedTabs = (tabs: DocumentationTabTypes[]): DocumentationTabTypes[] => {
  return tabs.filter((tab) => !tab._isNotRemovable);
};

/**
 * Merge default tabs with user-selected tabs from local storage
 */
export const mergeWithDefaultTabs = (
  defaultTabs: DocumentationTabTypes[],
  userTabs: DocumentationTabTypes[],
): DocumentationTabTypes[] => {
  return [...defaultTabs, ...userTabs];
};
